/*
 * ------------------------------------------
 * File Name: geo-tariff-warning.js
 * Description: This script handles the display logic for the GEO Tariff Warning popup. It detects the user's geographic location using Shopify's Geo Location API and, based on admin-configured countries, 
 *              displays a warning popup (e.g., for Canadian customers regarding tariffs). The popup is configurable via the geo-tariff-warning.liquid section and uses cookies to control frequency.
 * Author: Jahnavi Gottimukkala
 * Date Created: 2025-06-23
 * Last Modified: 
 * Version: 1.0
 * ------------------------------------------
 *
 * Usage:
 *   - Include this script in the relevant HTML files where the countdown timer needs to be displayed.
 *   - Ensure moment.js and jQuery libraries are loaded before this script.
 *
 * Functions:
 *   1. geoLocation(): Fetches user's location and determines whether to show the popup.
 *   2. geoPopup(country): Displays the popup and adjusts page opacity.
 *   3. getCookie(name): Retrieves a cookie value by name.
 *   4. setCookie(cname, cvalue, exdays): Sets a cookie with a specified expiry.
 *
 * ------------------------------------------
 */

$(function () {
  geoLocation();
});

function geoLocation() {
  // Shopify geo location endpoint
  const geoEndpoint = "/browsing_context_suggestions.json";

  // Ajax request to get geo data
  $.ajax({
    type: "get",
    url: geoEndpoint,
    dataType: "json",
    success: function (response) {
      // User country from response
      var userCountry = response.detected_values.country_name;

      // Remove spaces from included countries (array set in geo-tariff-warning.liquid + settings_data.json)
      includedCountries = includedCountries.map((country) => country.trim().toLowerCase());

      // // If user is from EU store, set cookie already to hide popup
      // if (document.referrer.indexOf('https://latitude64.com') > -1) {
      //   setCookie('geotariff', 'hidden', geoTariffExpiry);
      // }

      // Call geo popup function if enabled (variable set in geo-tariff-warning.liquid + settings_data.json), 
      // user country is included, popup cookie is not set
      if (geoTariffEnabled && includedCountries.includes(userCountry.toLowerCase()) && getCookie('geotariff') == null) {
        // Delay for geo popup (variable set in geo-tariff-warning.liquid + settings_data.json)
        setTimeout(geoPopup, geoTariffDelay, userCountry);
      }
    },
    fail: function (jqXHR, textStatus, errorThrown) {
      console.log('There was an error:' + jqXHR, textStatus, errorThrown);
    },
  });
}

function geoPopup(country) {
  // jQuery object from our popup
  $geoTariffPopup = $('.geo-tariff-popup');

  // Attach user country to popup header
  $geoTariffPopup.find('.section__title-desc').append(' ' + country);

  // Fade in geo-tariff-popup
  $geoTariffPopup.removeClass('hidden').animate({opacity: '1'}, 500);

  // Make popup stand out by lowering opacity on header, main and footer
  $('#content, .shopify-section-group-header-group, .shopify-section-group-footer-group').css('opacity', '0.3');

  // Set geotariffpopup cookie on accept or x click with expiry and hide popup
  $('.geo-tariff-popup .geo-tariff-popup__accept, .geo-tariff-popup .geo-tariff-popup__close').on('click', function () {
    setCookie('geotariff', 'hidden', geoTariffExpiry);
    $('.geo-tariff-popup').hide();
    $('#content, .shopify-section-group-header-group, .shopify-section-group-footer-group').css('opacity', '1');
  });
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
